export default "__VITE_ASSET__DFSb_fdg__"